import React from 'react';
import EditProfileForm from '../../../components/organism/EditProfileForm/EditProfileForm';

function EditProfile() {
  return <EditProfileForm />;
}

export default EditProfile;
